import { api } from '@/lib/api.js';

// THE PEOPLE SUGGESTIONS' SENDERS (people-create-door R26, Q14; the routes are R24,
// routes/tracon-people-suggestions.routes.js). Broker only. A suggestion is what a door
// heard (a person on a call, a new number for a person on file); David accepts or
// dismisses it here. The refusals below are answers the caller says itself (one toast,
// in the server's words), so api.js does not toast twice.

const EXPECTED = [
  { status: 409, code: 'people_off' },
  { status: 503, code: 'people_switch_unreadable' },
  { status: 409, code: 'match_found' },
  { status: 400, code: 'confirm_required' },
  { status: 409, code: 'already_resolved' },
  { status: 409, code: 'crm_contact_taken' },
  { status: 409, code: 'wrong_kind' },
  { status: 409, code: 'people_not_authoritative' },
  { status: 503, code: 'write_store_unreadable' },
  { status: 400, code: 'bad_request' },
  { status: 400, code: 'fields_required' },
  { status: 400, code: 'nothing_to_write' },
  { status: 400, code: 'label_required' },
  { status: 404, code: 'not_found' },
];

// Every open suggestion, each with its candidates, its subject and its proposed accounts named.
export function listPeopleSuggestions() {
  return api.get(`/api/tracon/people-suggestions?_t=${Date.now()}`);
}

// person_new: { existing_person_id } | { fields, confirm, account_id, role } | { agency_role }, confirm_new
// person_update: { kind: 'person_update', only: [field], confirm: { [field]: proposed } }
export function acceptPeopleSuggestion(id, body) {
  return api.post(`/api/tracon/people-suggestions/${encodeURIComponent(id)}/accept`, body, { expected: EXPECTED });
}

export function dismissPeopleSuggestion(id, reason) {
  return api.post(`/api/tracon/people-suggestions/${encodeURIComponent(id)}/dismiss`, { reason }, { expected: EXPECTED });
}
